export default function track(eventName, data) {
  // eslint-disable-next-line no-undef
  mixpanel.track(eventName, data);
}

export function identify(USER_ID) {
  // eslint-disable-next-line no-undef
  mixpanel.identify(USER_ID);
}
